var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9164_10290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.1625 24.8375 0 16 0C7.1625 0 0 7.1625 0 16C0 23.5 5.16875 29.8 12.1375 31.5312V20.8875H8.8375V16H12.1375V13.8938C12.1375 8.45 14.6 5.925 19.95 5.925C20.9625 5.925 22.7125 6.125 23.4312 6.325V10.75C23.0562 10.7125 22.4 10.6875 21.5812 10.6875C18.9562 10.6875 17.9438 11.6812 17.9438 14.2625V16H23.1688L22.2687 20.8875H17.9375V31.8813C25.8625 30.925 32 24.1812 32 16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9164_10290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.32b05016e9c791042e06f7b14d46396d.svg";
export { ForwardRef as ReactComponent };